module.exports = __webpack_public_path__ + "static/media/plastic_bag.e962b15a.svg";